import { TextInput } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import SectionTitle from '../../../components/text/SectionTitle';
import { TranslationsKeys } from '../../../locales/translations';
import { formatDate } from '../../../utils/dates';

export interface FormViewProps {
  date: string;
  createdAt: string | null;
  graduationGrade: string;
  degreeGrade?: string;
  distinctionRank: string;
  registerCode?: string;
  certificateNumber?: string;
  registryBook?: string;
}

export default function FormView(props: FormViewProps) {
  const { t } = useTranslation(TranslationsKeys.DEGREE_POOCESSES_MAIN);

  const texts = useMemo(
    () => ({
      sectionTilte: t(`form.sectionTitle`),
      distinctionRankLabel: t(`form.distinctionRank`),
      graduationGradeLabel: t(`form.graduationGrade`),
      degreeGradeLabel: t(`form.degreeGrade`),
      registerCodeLabel: t(`form.registerCode`),
      certificateNumberLabel: t(`form.certificateNumber`),
      registryBookLabel: t(`form.registryBook`),
      dateLabel: t(`form.date`),
      createdAtLabel: t(`form.createdAt`),
    }),
    [t],
  );

  return (
    <>
      <div className="mt-4 mb-2">
        <SectionTitle text={texts.sectionTilte} />
      </div>
      <Row>
        <Col className="pb-3" xs={12} xl={6}>
          <TextInput
            name="distinctionRank"
            label={texts.distinctionRankLabel}
            value={props.distinctionRank}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="graduationGrade"
            label={texts.graduationGradeLabel}
            value={props.graduationGrade}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="degreeGrade"
            label={texts.degreeGradeLabel}
            value={props.degreeGrade}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="date"
            label={texts.dateLabel}
            value={formatDate(props.date, 'DD/MM/YYYY')}
            readOnly
          />
        </Col>
        {!!props.registerCode?.trim() && (
          <Col className="pb-3" xs={12} xl={3}>
            <TextInput
              name="registerCode"
              label={texts.registerCodeLabel}
              value={props.registerCode?.trim()}
              readOnly
            />
          </Col>
        )}
        {!!props.certificateNumber?.trim() && (
          <Col className="pb-3" xs={12} xl={3}>
            <TextInput
              name="certificateNumber"
              label={texts.certificateNumberLabel}
              value={props.certificateNumber?.trim()}
              readOnly
            />
          </Col>
        )}
        {!!props.registryBook?.trim() && (
          <Col className="pb-3" xs={12} xl={3}>
            <TextInput
              name="registryBook"
              label={texts.registryBookLabel}
              value={props.registryBook?.trim()}
              readOnly
            />
          </Col>
        )}
      </Row>
    </>
  );
}
